import { Animation, Delay, Easing, Sequence } from "../../animation";
import type { IVector3 } from '../../defines/IVector3';
import { ease_linearity } from "../../utils/easing/ease_linearity";
import { UIComponent } from "./UIComponent";

export class ScaleAnimation extends UIComponent {
  static override readonly TAGS: string[] = ["ScaleAnimation"];
  protected seq_anim: Sequence = new Sequence();
  protected values = new Map<any, [IVector3, IVector3]>()
  start(v?: boolean) {
    this.seq_anim.start(v)
    this.enabled = true;
  }
  get is_end() {
    return this.seq_anim.done
  }
  override on_start(): void {
    super.on_start?.();
    const len = this.info.args.length;
    const anims: Animation[] = [];
    for (let i = 0; i < len - 2; i += 2) {
      const scale = this.vec3(i + 2) || this.node.scale;
      const duration = this.num(i + 3) || 0;
      const prev_scale = i == 0 ? scale : (this.vec3(i) || scale);
      const a = scale.equals(prev_scale) ?
        new Delay(0).set_duration(duration) :
        new Easing(0, 1)
          .set_duration(duration)
          .set_easing(ease_linearity)

      this.values.set(a,
        [
          prev_scale, scale.clone().sub(prev_scale)
        ])
      anims.push(a)
    }
    this.seq_anim = new Sequence(...anims).set_fill_mode(1)
    const is_play = this.bool(0) ?? true;
    const is_reverse = this.bool(1) ?? false;
    if (is_play) this.seq_anim.start(is_reverse)
    else this.seq_anim.end(is_reverse)
  }

  override update(dt: number): void {
    super.update?.(dt);
    if (!this.seq_anim.done) {
      this.seq_anim.update(dt);
      const pair = this.values.get(this.seq_anim.curr_anim)
      if (!pair) return;
      const { value } = this.seq_anim
      const [a, b] = pair;
      this.node.set_scale(
        a.x + b.x * value,
        a.y + b.y * value,
        a.z + b.z * value,
      )
    } else {
      this.set_enabled(false)
    }
  }
}

